export default __webpack_public_path__ + "static/media/studio-5.11ae20b1.png";